<template>
  <el-row class="_login-app">
    <el-col :span="24" :offset="0">
      <div
        style="display:flex;flex-direction:column;justify-content:center;height:100vh;"
        :style="isMB?'padding-top:6vh;':''"
      >
        <div class="login-box">
          <!-- <div class="title">网站后台管理系统</div> -->
          <div class="login_tip">{{isCert||isMB?'证书登录':'用户登录'}}</div>
          <el-form
            ref="form"
            :model="formData"
            :rules="formRules"
            size="large"
            @keyup.enter.native="login"
          >
            <!-- <el-form-item prop="Mobile">
              <el-input v-model="formData.Mobile" placeholder="手机号码" />
            </el-form-item>-->
            <el-form-item prop="LoginId" v-if="!isCert||isMB">
              <el-input v-model="formData.LoginId" prefix-icon="el-icon-user" placeholder="登录账号" />
            </el-form-item>
            <el-form-item prop="Pwd" v-if="!isCert||isMB">
              <el-input
                show-password
                prefix-icon="el-icon-lock"
                type="password"
                v-model="formData.Pwd"
                placeholder="登录密码"
              />
            </el-form-item>
            <el-row v-if="!isCert||isMB">
              <el-col :span="isMB?13:16" style="padding-right:10px;">
                <el-form-item prop="VerCode">
                  <el-input
                    prefix-icon="el-icon-key"
                    v-model="formData.VerCode"
                    placeholder="填写验证码"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="isMB?11:8">
                <s-identify :identifyCode="identifyCode" @refresh="refreshCode"></s-identify>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="isMB?13:15" style="padding-right:10px;">
                <el-form-item prop="Code">
                  <el-input v-model="formData.Code" placeholder="短信验证码" />
                </el-form-item>
              </el-col>
              <el-col :span="isMB?11:9">
                <el-button
                  style="width:100%"
                  :disabled="time!=0"
                  type="info"
                  plain
                  @click="sendCode"
                >
                  <span v-if="time==0">点击获取</span>
                  <span v-else>{{time}}s</span>
                </el-button>
              </el-col>
            </el-row>-->
            <el-button
              size="large"
              :loading="loading"
              type="primary"
              style="width:100%;"
              @click="login"
            >登录</el-button>
          </el-form>
          <!-- <div class="cName">中国联合网络通信有限公司汕头市分公司运营</div> -->
          <!-- <div style="text-align:right;" v-if="!isMB">
            <span class="DLclient" @click="DLclient">下载认证控件</span>
          </div> -->
        </div>
      </div>
    </el-col>
    <form id="form1" runat="server" />
    <input type="hidden" id="pinCode" value="false"/>
  </el-row>
</template>
<script>
var initParam = "<?xml version=\"1.0\" encoding=\"gb2312\"?><authinfo><liblist><lib type=\"CSP\" version=\"1.0\" dllname=\"\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib><lib type=\"SKF\" version=\"1.1\" dllname=\"SERfR01DQUlTLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib><lib type=\"SKF\" version=\"1.1\" dllname=\"U2h1dHRsZUNzcDExXzMwMDBHTS5kbGw=\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib><lib type=\"SKF\" version=\"1.1\" dllname=\"U0tGQVBJLmRsbA==\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib><lib type=\"SKF\" version=\"1.1\" dllname=\"bXRva2VuX2dtMzAwMC5kbGw=\" ><algid val=\"SHA1\" sm2_hashalg=\"sm3\"/></lib></liblist></authinfo>";
import sIdentify from "@/components/common/sIdentify";
// import pnxclient from "./js/pnxclient.js";
import gateway from "./js/gateway.js"

export default {
  components: {
    sIdentify,
  },
  data() {
    const validateCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("验证码不能为空"));
      } else if (this.identifyCode !== value) {
        this.formData.VerCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      api: require("@/api/sy/user").default,
      attach: require("@/api/common/attach").default,
      Base64: require("js-base64").Base64,
      identifyCode: "",
      loading: false,
      formData: {
        // Mobile: "",
        LoginId: "",
        Pwd: "",
        Code: "",
        VerCode: "",
      },
      time: 0,
      interval: null,
      isCert: false,
      users: [],
      isMB: this.$store.state.isMB,
      formRules: {
        LoginId: [{ required: true, message: "请输入登录账号" }],
        Pwd: [{ required: true, message: "请输入登录密码" }],
        Code: [{ required: true, message: "请输入短信验证码" }],
        VerCode: [
          { validator: validateCode, trigger: "blur" },
          // { required: true, message: "请输入验证码" },
        ],
      },
    };
  },
  beforeMount() {
    if(!this.isMB) {
      // pnxclient.Init();
      // this.api.getAuth().then(res => {
      //   if(res.Code==0) this.isCert = res.Data;
      // })
    }
  },
  mounted() {
    this.refreshCode();
    // console.log('store',this.$store.state.user,this.$store.getters)
    let token = this.$commonJs.getCookie("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
          if (loginInfo) {
            if (loginInfo.ChangePwd == true) {
              this.$router.push("/password").catch((err) => {});
            } else {
              this.$router.push("/workbench").catch((err) => {});
            }
          }
        }
      });
    }
  },
  methods: {
    sendCode() {
      this.api.sendCode(this.formData.LoginId).then((res) => {
        if (res.Code == 0) {
          let self = this;
          self.time = 120;
          this.interval = setInterval(function () {
            self.time -= 1;
            if (self.time <= 0) {
              clearInterval(self.interval);
            }
          }, 1000);
        } else {
          if (res.Msg == null) {
            res.Msg = "发送失败";
          }
          this.$message.error(res.Msg);
        }
      });
    },
    login() {
      this.$refs.form
        .validate()
        .then((res) => {
          if (!res) return false;
          this.loading = true;
          //--------判断证书---------------
          if(this.isCert && !this.isMB) {
            this.api.getRandomOriginal().then(res => {
              if(res.Code==0) {
                var SrcData = res.Data;
                var SignedData = gateway.makeSignature(initParam,SrcData,"");
                if(SignedData) {
                  loginFun("loginByCert", { SignedData, SrcData });
                } else {
                  this.loading = false;
                }
              } else {
                this.$message.error("操作失败");
                this.loading = false;
              }
            })
          } else {
            loginFun();
          }
          //------------------------------
        })
        .catch((res) => {});
      var self = this;
      function loginFun(name="loginByMobile", data=self.formData) {
        self.$store.dispatch(name, data).then((res) => {
          if (res.Data.ChangePwd == true) {
            self.$store.dispatch("changeSetting", {
              key: "fixedHeader",
              value: false,
            });
            self.$router.push("/password").catch((err) => {});
          } else {
            self.$router.push("/workbench").catch((err) => {});
          }
        }).catch((res) => {
          self.$message.error(res.Msg);
          self.loading = false;
          if(!self.isCert || isMB) self.refreshCode();
        });
      }
    },
    refreshCode() {
      this.identifyCode = "";
      this.api.getVerCode().then((res) => {
        this.identifyCode = this.Base64.decode(res);
        console.log(this.identifyCode);
      });
      // for (let i = 0; i < 4; i++) {
      //   this.identifyCode += this.randomNum(0, 9);
      // }
    },
    DLclient() {
      var url = "/template/cab.zip";
      this.attach.downloadByUrl(url, "认证控件.zip");
    },
    // randomNum(min, max) {
    //   return Math.floor(Math.random() * (max - min) + min);
    // },
  }
};
</script>
<style lang="scss">
._login-app {
  .login_title {
    color: #fff;
    text-align: center;
    margin-bottom: 14vh;
    width: 100%;
    font-size: 44px;
    letter-spacing: 16px;
    @media screen and (max-width: 767px) {
      padding: 0 15%;
      font-size: 28px;
      margin-bottom: 10vh;
      letter-spacing: 2px;
    }
  }
  .login_tip {
    margin: 0px 0 15px;
    @media screen and (max-width: 767px) {
      margin: 0 0 10px;
    }
  }
  // @media screen and (max-width: 767px) {
  //   background-image: url("../assets/bgPic_MB.jpg");
  //   background-size: 100% 100%;
  // }
  @media screen and (min-width: 768px) {
    background-image: url("../assets/bgPic.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }
  .login-box {
    z-index: 1000;
    border-radius: 12px;
    width: 380px;
    margin: 0px auto;
    border: 1px solid #ebeef5;
    padding: 25px 25px 30px;
    background-color: #fff;
    @media screen and (max-width: 767px) {
      width: 80%;
      padding: 15px 25px 20px;
    }
    .title {
      height: 40px;
      font-weight: bold;
      font-family: "宋体";
      font-size: 24px;
      text-align: center;
      letter-spacing: 1px;
      margin-bottom: 12px;
      @media screen and (max-width: 767px) {
        font-size: 20px;
      }
    }

    .forget-pwd {
      font-size: 16px;
      margin-top: 5px;
      display: inline-block;
      color: gray;
      cursor: pointer;
    }
  }
  .DLclient {
    display: inline-block;
    margin-top: 7px;
    color: #409EFF;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>